<template>
    <div>
        <h2>Data Deletion</h2>
        <p>Please contact us at info@igloocreations.com so we can proceed with your request.</p>
        <p>Thank you!</p>
    </div>    
</template>

<script>
export default {
    
}
</script>

<style scoped>

</style>